/**
 * handleErrors
 *
 * Error handling
 *
 * @param {Object} el
 * @param {string} str
 */
const handleErrors = ( el, str ) => {
  const errorMessage = el.querySelector( '.error-message' );
  errorMessage.innerText = str;

  el.classList.add( 'has-error' );
  el.querySelector( '.error-message' ).classList.remove( 'is-hidden' );
  el.querySelector( '.error-message' ).classList.add( 'is-visible' );
};

/**
 * resetErrors
 *
 * Resets error handling
 *
 * @param {Object} el
 */
const resetErrors = ( el ) => {
  el.classList.remove( 'has-error' );
  el.querySelector( '.error-message' ).classList.add( 'is-hidden' );
  el.querySelector( '.error-message' ).classList.remove( 'is-visible' );
};

/**
 * delay
 *
 * sets a timer
 *
 * @param {number} ms
 * @return {Object} promise
 */

const delay = ( ms ) => new Promise( ( resolve ) => setTimeout( resolve, ms ) );

/**
 * getQueryString
 *
 * Checks for URL params and returns the one we need when we call it
 *
 * @param {string} param
 * @param {string} link
 * @return {string} item
 */
const getParam = ( param, link ) => {
  const searchParams = new URLSearchParams( link );

  if ( !searchParams.has( param ) ) {
    return;
  }

  let item;

  searchParams.forEach( ( value, key ) => {
    if ( key === param ) {
      item = value;
    }
  });

  return item;
};

/**
 * getQueryString
 *
 * Returns a query string
 *
 * @param {string} str
 * @return {string} str
 */
const getQueryString = ( str ) => str.substring( str.indexOf( '?' ) + 1 );

/**
 * validateEmail
 *
 * Validates email address against a Regular Expression
 *
 * @param {string} str
 * @return {boolean} true/false
 */
const validateEmail = ( str ) => {
  const regex = /^\w+([-.'+]\w+)*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  return regex.test( str );
};

/**
 * filterOutWhiteSpace
 *
 * Handles error messaging if any required attrs are missing
 *
 * @param {Array} classNames
 */
const filterOutWhiteSpace = ( classNames ) => classNames.filter( Boolean ).join( ' ' );

/**
 * capitalizeFirstLetter
 *
 * @param {str} words/sentences that need to be capitalized
 * @return { str }
 */
const capitalizeFirstLetter = ( str ) => str.charAt( 0 ).toUpperCase() + str.slice( 1 );

/**
 * capitalizeEachLetter
 *
 * @param {str} words/sentences that need to be capitalized
 * @return { str }
 */
const capitalizeEachLetter = ( str ) => str.toLocaleLowerCase().split( '-' ).map( ( item ) => item.charAt( 0 ).toUpperCase() + item.substring( 1 ) ).join( ' ' );

/**
 * formatStr
 *
 * @param {str} strip out special characters and number and replace with hyphen
 * @return { str }
 */
const formatStr = ( str ) => str.toLowerCase().replace( /[^A-Z]+/ig, '-' );

export {
  capitalizeEachLetter, capitalizeFirstLetter, delay, filterOutWhiteSpace, formatStr, getParam,
  getQueryString, handleErrors,
  resetErrors, validateEmail
};
